import * as React from 'react';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';
import { FramesBundleContentDescription } from './FramesBundleContentDescription.js';

const FramesBundleContentDescriptionContainer = ({ className  })=>{
    const { selectedOffering  } = useFramesEcommContext();
    if (!(selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.bundleContentDescription)) return null;
    return /*#__PURE__*/ React.createElement(FramesBundleContentDescription, {
        description: selectedOffering.bundleContentDescription,
        className: className
    });
};

export { FramesBundleContentDescriptionContainer };
//# sourceMappingURL=FramesBundleContentDescriptionContainer.js.map
